import React, { useState, useEffect } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../../lib/whatsapp';

const links = [
  { href: '#top', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#testimonials', label: 'Testimonials' },
  { href: '#faq', label: 'FAQs' }
];

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const bookConsult = () => {
    openWhatsApp('Namaste Nitika Ji, I would like to book a consultation.');
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-black/85 backdrop-blur-md border-b border-[#D4AF37]/15' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
        <a
          href="#top"
          className="font-['Cormorant_Garamond'] text-lg sm:text-xl tracking-wide text-white"
          data-testid="nav-brand"
        >
          Nitika <span className="text-[#D4AF37]">Bhola</span>
        </a>

        {/* Desktop links */}
        <ul className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-[#D4AF37] transition-colors duration-200"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <button
            type="button"
            onClick={bookConsult}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black text-xs uppercase tracking-[0.15em] font-semibold px-4 py-2 rounded-full hover:shadow-lg transition-shadow"
            data-testid="nav-book-cta"
          >
            <MessageCircle className="w-3.5 h-3.5" />
            Book
          </button>
        </div>

        {/* Mobile menu button */}
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="md:hidden text-white/85 p-2"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-[#D4AF37]/15">
          <ul className="px-4 py-3 space-y-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setMobileOpen(false)}
                  className="block py-3 text-sm text-[#E8DCC4] uppercase tracking-[0.15em] hover:text-[#D4AF37] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <button
                type="button"
                onClick={bookConsult}
                className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black text-sm font-semibold py-3 rounded-full"
              >
                <MessageCircle className="w-4 h-4" />
                Book Consultation
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};
